import moment from 'moment'
const statusOptions = [
	{
		value:'-2',
		text:'待完善'
	},
	{
		value:'-1',
		text:'已取消'
	},
	{
		value:'0',
		text:'待支付'
	},
	{
		value:'1',
		text:'投保成功'
	},
	{
		value:'2',
		text:'已退保'
	},
	{
		value:'3',
		text:'已支付，投保失败'
	},
	{
		value:'11',
		text:'核保中'
	},
	{
		value:'14',
		text:'核保失败'
	},
];
const recordsStateOptions=[
	{
		name:"成功",
		value:'1'
	},
	{
		name:"失败",
		value:'2'
	},
	{
		name:"等到生效",
		value:'3'
	}
]
const recordsTypeOptions=[
	{
		name:"首次",
		value:'1'
	},
	{
		name:"追加保单",
		value:'2'
	},
	{
		name:"减少保单",
		value:'3'
	}
]
const idTypeOptions=[
		{
			value:'1',
			text:'身份证'
		},
    {
      value:'01',
      text:'身份证'
    },
    {
      value:'2',
      text:'护照'
    },
    {
      value:'02',
      text:'护照'
    },
    {
      value:'3',
      text:'军人证'
    },
    {
      value:'03',
      text:'军人证'
    },
    {
      value:'4',
      text:'港澳通行证'
    },
    {
      value:'04',
      text:'港澳通行证'
    },
    {
      value:'5',
      text:'驾驶证'
    },
    {
      value:'05',
      text:'驾驶证'
    },
    {
      value:'6',
      text:'港澳回乡证或台胞证'
    },
    {
      value:'06',
      text:'港澳回乡证或台胞证'
    },
    {
      value:'7',
      text:'临时身份证'
    },
    {
      value:'07',
      text:'临时身份证'
    },
    {
      value:'8',
      text:'出生证'
    },
    {
      value:'08',
      text:'出生证'
    },
    {
      value:'9',
      text:'户口本'
    },
    {
      value:'09',
      text:'户口本'
    },
    {
      value:'10',
      text:'外国护照'
    },
    {
      value:'11',
      text:'士兵证'
    },
    {
      value:'12',
      text:'台湾居民来往内地通行'
    },
    {
      value: '13',
      text: '工作证'
    },
    {
      value: '14',
      text: '学生证'
    },
    {
      value: '15',
      text: '军官离退休证'
    },
    {
      value: '16',
      text: '警官证'
    },
    {
      value: '17',
      text: '旅行证'
    },
    {
      value: '18',
      text: '台湾居民居住证'
    },
    {
      value: '19',
      text: '大陆居民往来台湾通行证'
    },
    {
      value: '20',
      text: '港澳居民居住证'
    },
    {
      value: '21',
      text: '港澳居民来往内地通行证'
    },
    {
      value: '22',
      text: '回乡证'
    },
    {
      value: '23',
      text: '外国人永久居留证'
    },
    {
      value: '24',
      text: '无证件'
    },
    {
      value:'99',
      text:'其它'
    },
]
const companyIdTypeOptions = [
    {
      value:'01',
      text:'组织机构代码证'
    },
    {
        value:'14',
        text:'组织机构代码证'
    },
    {
      value:'02',
      text:'税务登记证'
    },
    {
      value:'03',
      text:'统一社会信用代码证'
    },
    {
        value:'13',
        text:'统一社会信用代码证'
      },
    {
      value:'110004',
      text:'统一社会信用代码证'
    },
    {
        value:'15',
        text:'个体经营者营业执照'
    },
    {
      value:'04',
      text:'工商营业执照'
    },
    {
      value:'05',
      text:'统一社会信用代码（五证合一号码）'
    },
    {
      value:'06',
      text:'金融许可证号码'
    },
    {
      value:'07',
      text:'国家主管部门颁外国驻华机构批文号'
    },
    {
      value:'99',
      text:'其它'
    },
    {
      value:'100',
      text:'其他类境外机构代码'
    },
]
const filters = {
	// 保单状态
	orderStatus(val){
		if (!val) {
		  return;
		}
		const item = statusOptions.find((item) => {
		  return item.value == val;
		});
		return item?item.text:val;
	},
	recordsState(val){
		if (!val) {
		  return;
		}
		const item = recordsStateOptions.find((item) => {
		  return item.value == val;
		});
		return item?item.name:val;
	},
	recordsType(val){
		if (!val) {
		  return;
		}
		const item = recordsTypeOptions.find((item) => {
		  return item.value == val;
		});
		return item?item.name:val;
	},
	filterNull(val,unit=''){
		if(!val) return '-'
		if(val=='null'||val=='undefined'||val=='0'){
			return '-'
		}
		return `${val}${unit}`
	},
	filterIdType(val){
		if (!val) {
		  return;
		}
		const item = idTypeOptions.find((item) => {
		  return item.value == val;
		});
		return item?item.text:val;
	},
    filterCompanyIdType(val){
		if (!val) {
		  return;
		}
		const item = companyIdTypeOptions.find((item) => {
		  return item.value == val;
		});
		return item?item.text:val;
	},
	filterGuaranteePeriod:(val)=>{
		if(!val){
			return '-'
		}else{
			if(!/^\d+$/.test(val)){
				return val
			}else{
				return '保至'+val+'岁'
			}
		}
	},
	filterDate:(val)=>{
		if(!val){
			return '-'
		}else{
			let diff=moment(val).diff(moment(),'days')+1
			return diff
		}
	},
	filterAbsDate:(val)=>{
		if(!val){
			return '-'
		}else{
			let diff=moment(val).diff(moment(),'days')+1
			return Math.abs(diff)
		}
	},
	filterDateType:(val)=>{
		if(!val){
			return '-'
		}else{
            if(val.substring(0,4)<2000){
                return '长期'
            }
			let val_=val.substring(0,4)+'年'+val.substring(5,7)+'月'+val.substring(8,10)+'日'
			return val_
		}
	},
    filterExpireDate:(val)=>{
        if(!val){
            return '-'
        }else{
            if(val.substring(0,4)<2000){
            	return '长期'
			      } else if (val.substring(0,4)=='2199') {
              return '终身'
            }
            return val
        }
    },
	filterMedicalIdType:(val)=>{
		if(!val){
			return '-'
		}else{
			if(val=="0") return '身份证'
			if(val=="1") return '护照'
			if(val=="2") return '港澳通行证'
			if(val=="8") return '其他'
		}
	},
  filterAmount(val) {
    if(!val) return '-'
    if(val=='null'||val=='undefined'||val=='0'){
      return '-'
    }
    return val + '元'
  },
  filterWaitDate(val) {
    if(!val) return '-'
    if(val=='null'||val=='undefined'){
      return '-'
    }
    return val + '天'
  },
  filterStatus:(val,options)=>{
      if(!val){
          return '-'
      }else{
          let name = '-'
          for(let i = 0; i < options.length; i++) {
              if (options[i].value === val || options[i].text === val) {
                  name = options[i].text;
                  break;
              }
          }
          return name;
      }
  },
  filterNumber:(val)=>{
    if(!val){
        return '-'
    } else {
        if(!/^\d+$/.test(val)){
            return val
        }else{
            return '保至'+val+'岁'
        }
    }
},
}

export default filters;